import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js";
import ImageHandler from "components/explore/lists/ImageHandler.js";
import ZoraField from "components/nft/ZoraField.js";
import {updatePlugin, createPlugin} from 'plugins/plugins.js';
import React, { useEffect, useCallback, useState} from 'react';
import {
    setPluginToSave,
    } from 'actions/index.js';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import { Button } from 'reactstrap';

const SavePluginModal = ({
    zobject,
    setPluginToSave
}) => { 

    console.log("zobject.plugin=", zobject.plugin, zobject);

    const [name, setName] = useState(zobject.plugin ? zobject.plugin.name : '');
    const [description, setDescription] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const mintPlugin = useCallback(() => {
        let json = zobject.getPresetJson();
        if (zobject.plugin) {
            // then we updating
            updatePlugin(json, name, description, thumbnail, zobject.plugin.tokenId);
        } else {
            createPlugin(json, name, description, thumbnail, {creatorShare: 4, ownerShare: 4, minterShare: 92});
        }
    }, [zobject, name, description, thumbnail]);
    
    return (
        <Modal
          dialogClassName="zora-modal preset-modal"
          show={true}
          onHide={() => {
              setPluginToSave(undefined);
          }}
        >
          <Modal.Body>
            <div className="zora-configuration">
              <ZoraField set={setName} get={name} name="name"/>
              <ZoraField set={setDescription} get={description} name="description" isTextArea={true}/>
              <ImageHandler placeholder="Drop the thumbnail image for your work, here" imageHash={thumbnail} setImageHash={setThumbnail}/>
            </div>
         </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={mintPlugin}>
              {zobject.plugin ? "Update Plugin" : "Mint Plugin"}
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
      mintingProgress: state.nft.mintingProgress,
      newZoraTokenId: state.nft.newZoraTokenId
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPluginToSave: x => dispatch(setPluginToSave(x))
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(SavePluginModal);
